import { Site } from '@utils/models';
import useSWR from 'swr';

const useSites = () => {
  const { data } = useSWR<{ sites: Site[] }>('/sites');
  return data?.sites || [];
};

export default useSites;
